
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 440 440","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Symbols_1_"}},[_c('g',{attrs:{"id":"Group-24","transform":"translate(80 34.76)"}},[_c('path',{staticClass:"st0",attrs:{"id":"Fill-1_1_","d":"M261.6 358.4H18.4c-3.8 0-6.8-3.1-6.8-6.8V18.8c0-3.7 3.1-6.8 6.8-6.8H198v51.6c0 10.4 8.4 18.8 18.8 18.8h51.6v269.2c0 3.8-3.1 6.8-6.8 6.8zM210 20.5l49.9 49.9h-43.1c-3.8 0-6.8-3.1-6.8-6.8V20.5zm68.6 51.7L208.2 1.8C207.1.7 205.6 0 204 0H18.4C8 0-.4 8.5-.4 18.8v332.8c0 10.4 8.4 18.8 18.8 18.8h243.2c10.4 0 18.8-8.4 18.8-18.8V76.4c0-1.6-.6-3.1-1.8-4.2z"}}),_c('path',{staticClass:"st0",attrs:{"id":"Combined-Shape","d":"M235.6 288.6c3.3 0 6 2.7 6 6s-2.7 6-6 6h-192c-3.3 0-6-2.7-6-6s2.7-6 6-6h192zm-192-42h192c3.3 0 6 2.7 6 6 0 3.2-2.6 5.9-5.8 6H43.6c-3.3 0-6-2.7-6-6 0-3.2 2.6-5.9 5.8-6h192.2-192zm192-42c3.3 0 6 2.7 6 6 0 3.2-2.6 5.9-5.8 6H43.6c-3.3 0-6-2.7-6-6 0-3.2 2.6-5.9 5.8-6h192.2zm0-42c3.3 0 6 2.7 6 6 0 3.2-2.6 5.9-5.8 6H43.6c-3.3 0-6-2.7-6-6 0-3.2 2.6-5.9 5.8-6h192.2zm-115.2-42c3.3 0 6 2.7 6 6 0 3.2-2.6 5.9-5.8 6h-77c-3.3 0-6-2.7-6-6 0-3.2 2.6-5.9 5.8-6h77z"}})])])])
          )
        }
      }
    